import React, { Component } from 'react';
import RouteTitle from '../../../shared/route-title/RouteTitle';
import { connect } from 'react-redux';
import './Tasks.css';
import { Col } from 'react-bootstrap';
import Task from './Task';
import leftArrowPng from '../../../../images/left-arrow.png';
import ConfirmationPanel from '../../../shared/confirmation/ConfirmationPanel';
import alertTrianglePng from '../../../shared/confirmation/alert-triangle.png';
import numeral from 'numeral';
import {
  addEmptyTask,
  cancelTaskHide,
  cancelTaskRequest,
  cancelTaskShow,
  currentTaskChangeRequest,
  editTask,
  initializeTasksState,
  loadTradesRequest,
  removeImageRequest,
  saveTaskRequest,
  taskBack,
  taskContinue,
  updateTaskRequest,
} from '../../../../actions/admin/work-orders/creation/tasks';
import { loadSubTradesRequest } from '../../../../actions/admin/work-orders/work-orders';
import {
  getCurrentTask,
  getEditTaskId,
  getShowCancel,
} from '../../../../selectors/admin/work-orders/creation/tasks';
import TasksUtil from '../../../../services/utils/tasks-util';
import {
  getCurrentWorkOrder,
  getSubTradesByTradeId,
  getTasks,
  getTrades,
} from '../../../../selectors/admin/work-orders/work-orders';
import { showWOCancellationModal } from '../../../../actions/admin/work-orders/creation/creation';
import CancelWorkOrder from './CancelWorkOrder';
import { getNewWOProcessStarted } from '../../../../selectors/admin/work-orders/creation/creation';
import {
  simpleScrollTo,
  simpleScrollToTop,
} from '../../../../services/utils/scroller-util';

class Tasks extends Component {
  minMaxImages = {
    min: 3,
    max: 6,
  };

  componentDidMount() {
    this.props.dispatch(loadTradesRequest());
    this.props.dispatch(
      initializeTasksState(
        this.props.editTaskId,
        this.props.tasks,
        this.props.currentTask,
        this.props.currentWorkOrder.client.company_name
      )
    );

    if (this.props.editTaskId > 0) {
      simpleScrollTo(this.props.editTaskId.toString());
    }
  }

  handleTaskChange = (taskId, attribute, value, label) => {
    this.props.dispatch(
      currentTaskChangeRequest(taskId, attribute, value, label)
    );
    if (attribute === 'trade') {
      this.props.dispatch(loadSubTradesRequest(value));
    }
  };

  handleTaskSubmit = () => {
    if (this.props.currentTask.id === 0) {
      this.props.dispatch(
        saveTaskRequest(this.props.currentTask, this.props.currentWorkOrder.id)
      );
    } else {
      this.props.dispatch(updateTaskRequest(this.props.currentTask));
    }
  };

  handleTaskEdit = (taskId) => {
    this.props.dispatch(editTask(taskId, this.props.tasks));
  };

  handleAddAdditionalTask = () => {
    this.props.dispatch(addEmptyTask(this.props.tasks));
  };

  handleTaskCancel = () => {
    this.props.dispatch(cancelTaskShow());
  };

  handleTaskCancelYes = () => {
    this.props.dispatch(cancelTaskRequest(this.props.currentTask.id));
  };

  handleTaskCancelNo = () => {
    this.props.dispatch(cancelTaskHide());
  };

  handleBackArrow = (event) => {
    event.preventDefault();
    this.props.dispatch(taskBack());
  };

  handleTaskContinue = (event) => {
    event.preventDefault();
    simpleScrollToTop();
    this.props.dispatch(taskContinue(this.props.newWOProcessStarted));
  };

  handleCancelOrder = (event) => {
    event.preventDefault();
    this.props.dispatch(showWOCancellationModal());
  };

  handleTaskCancelOrder = () => {
    this.props.dispatch(showWOCancellationModal());
  };

  handleImageRemove = (index) => {
    this.props.dispatch(removeImageRequest(this.props.currentTask, index));
  };

  render() {
    return (
      <div className="tasks-creation">
        <RouteTitle
          titles={['WORK ORDERS', 'WO #' + this.props.currentWorkOrder.number]}
        />

        <div className="full-title light">
          Work Order #{this.props.currentWorkOrder.number}
        </div>

        <Col md={8} className="column">
          <div className="content-container">
            {!this.props.showCancel ? (
              <React.Fragment>
                {
                  /* Only show back button if WO is under creation */
                  this.props.newWOProcessStarted && (
                    <div className="image-back-container">
                      <img
                        src={leftArrowPng}
                        alt={'left-arrow'}
                        onClick={this.handleBackArrow}
                      />
                    </div>
                  )
                }

                <div className="tasks">
                  {
                    // Iterate over existing tasks
                    this.props.tasks
                      .slice() // copy task for sorting
                      .sort(Tasks.sortTasks)
                      .map((task) => {
                        const readOnly = task.id !== this.props.editTaskId;
                        let localSubTradesByTradeId = this.props
                          .subTradesByTradeId;
                        if (readOnly) {
                          localSubTradesByTradeId = {};
                          // If read only, simulate the sub trades with the value of the task
                          localSubTradesByTradeId[task.trade.id] = [
                            task.sub_trade,
                          ];
                        }
                        return (
                          <Task
                            key={task.id}
                            minMaxImages={this.minMaxImages}
                            readOnly={readOnly}
                            task={
                              readOnly
                                ? TasksUtil.mapTask(task)
                                : this.props.currentTask
                            }
                            trades={this.props.trades}
                            subTradesByTradeId={localSubTradesByTradeId}
                            onCancel={this.handleTaskCancel}
                            onCancelOrder={this.handleTaskCancelOrder}
                            onChange={this.handleTaskChange}
                            onEdit={this.handleTaskEdit}
                            onImageRemove={
                              readOnly ? undefined : this.handleImageRemove
                            }
                            onSubmit={this.handleTaskSubmit}
                          />
                        );
                      })
                  }

                  {this.props.editTaskId === 0 ? (
                    <Task
                      key={0}
                      minMaxImages={this.minMaxImages}
                      readOnly={false}
                      task={this.props.currentTask}
                      trades={this.props.trades}
                      subTradesByTradeId={this.props.subTradesByTradeId}
                      onCancel={this.handleTaskCancel}
                      onCancelOrder={this.handleTaskCancelOrder}
                      onChange={this.handleTaskChange}
                      onEdit={this.handleTaskEdit}
                      onImageRemove={this.handleImageRemove}
                      onSubmit={this.handleTaskSubmit}
                    />
                  ) : (
                    this.props.tasks.length === 0 && (
                      <div className="no-tasks">No Tasks</div>
                    )
                  )}
                </div>

                {this.props.editTaskId === -1 && (
                  <div className="button-container">
                    <input
                      className="btn button button-orange"
                      value="Add Additional Task"
                      type="button"
                      onClick={this.handleAddAdditionalTask}
                    />
                    <input
                      className={
                        'btn button button-gray' +
                        (this.props.tasks.length === 0 ? ' hidden' : '')
                      }
                      value="Continue"
                      type="button"
                      onClick={this.handleTaskContinue}
                    />
                    <input
                      className="btn button button-white"
                      value="Cancel Order"
                      type="button"
                      onClick={this.handleCancelOrder}
                    />
                  </div>
                )}
              </React.Fragment>
            ) : (
              <div className="confirmation-panel-container">
                <ConfirmationPanel
                  buttons={[
                    <input
                      className="btn button button-orange"
                      value="No"
                      type="button"
                      onClick={this.handleTaskCancelNo}
                    />,
                    <input
                      className="btn button button-gray"
                      value="Yes"
                      type="button"
                      onClick={this.handleTaskCancelYes}
                    />,
                  ]}
                  firstLine={
                    'Cancelling Task #' +
                    numeral(this.props.currentTask.number).format('00')
                  }
                  image={alertTrianglePng}
                  lines={[
                    'Are you sure you would like to cancel Task #' +
                      numeral(this.props.currentTask.number).format('00') +
                      '?',
                  ]}
                />
              </div>
            )}
          </div>
        </Col>

        <CancelWorkOrder />
      </div>
    );
  }

  static sortTasks(taskA, taskB) {
    if (taskA.number < taskB.number) {
      return -1;
    }
    if (taskA.number > taskB.number) {
      return 1;
    }
    return 0;
  }
}

export default connect((state) => {
  return {
    currentTask: getCurrentTask(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    editTaskId: getEditTaskId(state),
    newWOProcessStarted: getNewWOProcessStarted(state),
    showCancel: getShowCancel(state),
    subTradesByTradeId: getSubTradesByTradeId(state),
    tasks: getTasks(state),
    trades: getTrades(state),
  };
})(Tasks);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/Tasks.js